import Tooltip from 'components/Tooltip';
import Text from 'components/ui/Text';
import { useTranslation } from 'hooks/useTranslation';
import { FC } from 'react';

type RecommendedWithTooltipType = {
  tooltip?: {
    title?: string;
    text: string;
  };
  tag?: string;
};

const Tag = ({ text }: { text: string }) => (
  <div className="py-[4px] px-[6px] flex items-center justify-center bg-gray-300 small-caps rounded-full">
    <Text
      bold
      color="blue"
      elementType="span"
      size="label"
      className="!text-[12px] !leading-none"
    >
      {text}
    </Text>
  </div>
);

const RecommendedWithTooltip: FC<RecommendedWithTooltipType> = ({
  tag,
  tooltip,
}) => {
  const translation = useTranslation();
  const tagTitle = tag || translation('general.recommended');

  return (
    <div>
      {tooltip ? (
        <Tooltip
          content={
            <div className="text-sm tooltip">
              {tooltip.title && <h4>{tooltip.title}</h4>}
              <h4>{tooltip.text}</h4>
              {/* <RichText text={option.titleAndDesc?.description || []} /> */}
            </div>
          }
        >
          <Tag text={tagTitle} />
        </Tooltip>
      ) : (
        <Tag text={tagTitle} />
      )}
    </div>
  );
};

export default RecommendedWithTooltip;
